import { ReactElement, useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import images from 'const/images'
import { isLoginFlowPage } from 'helpers'
import Menu from 'ui/organisms/Menu'
import WelcomePanel from 'ui/organisms/WelcomePanel'
import query from 'mediaQueries'
import routePaths from 'const/routePaths'
import { clientInfo } from 'configureBrand'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import useMedia from 'syf-js-utilities/hooks/useMedia'
import { logout, selectAccessToken } from 'redux/authToken/authTokenSlice'
import { getVideos } from 'redux/videos/thunks'
import BaseHeader, { Logo } from 'ui/molecules/BaseHeader'
import { LargeTopBarMenu, MobileTopBarMenu } from './subcomponents'
import { useHideBodyOverflow } from './helpers'

const { logo } = images

const { logoAltText } = clientInfo

const Header = (): ReactElement => {
  const dispatch = useAppDispatch()
  const accessToken = useAppSelector(selectAccessToken)

  const isUserLoggedIn = useAppSelector(({ appInfo }) => appInfo.isUserLoggedIn)

  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)

  const hamburgerButtonRef = useRef<HTMLButtonElement>(null)

  const isGreaterThanMedium = useMedia<boolean>(
    [query.greaterThanMedium],
    [true],
    false
  )

  const isLoginFlow = isLoginFlowPage(useLocation().pathname)

  useHideBodyOverflow(isMenuOpen)

  /*
   * user is not logged in or in the process of authenticating (RSA, password
   * reset, etc.)
   */
  const isAuthenticated = accessToken && !isLoginFlow

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getVideos())
    }
  }, [dispatch, isAuthenticated])

  if (isAuthenticated) {
    return (
      <>
        <BaseHeader
          logo={
            <Link to={routePaths.summary}>
              <Logo alt={logoAltText} src={logo} />
            </Link>
          }
        >
          {isGreaterThanMedium ? (
            <LargeTopBarMenu isAuthenticated />
          ) : (
            <MobileTopBarMenu
              isOpen={isMenuOpen}
              onToggleOpen={() =>
                setIsMenuOpen(prevIsMenuOpen => !prevIsMenuOpen)
              }
              hamburgerButtonRef={hamburgerButtonRef}
            />
          )}
        </BaseHeader>

        <WelcomePanel compact={!isGreaterThanMedium} />
        <Menu
          closeMenu={(): void => {
            setIsMenuOpen(false)
            hamburgerButtonRef.current?.focus()
          }}
          isMenuActive={isMenuOpen}
          data-test="menu"
        />
      </>
    )
  }

  // User is not authenticated. Do not show protected content.
  return (
    <BaseHeader
      logo={
        <Link
          to={isUserLoggedIn ? routePaths.summary : routePaths.home}
          onClick={(): void => {
            if (!isUserLoggedIn) {
              dispatch(logout())
            }
          }}
        >
          <Logo alt={logoAltText} src={logo} />
        </Link>
      }
    />
  )
}

export default Header
